import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { CountryService } from "app/services/country.service";

import { DocumentsServiceService } from "app/services/documents-service.service";
import { AdminAnnualComplianceService } from "app/admin-annual-compliance/service/admin-annual-compliance.service";
import { DomSanitizer } from "@angular/platform-browser";
import { PermitTypeDocumentService } from "app/services/permit-type-document.service";
import { AnnualComplianceService } from "../service/annual-compliance.service";


@Component({
  selector: 'app-view-compliance-details',
  templateUrl: './view-compliance-details.component.html',
  styleUrls: ['./view-compliance-details.component.scss']
})
export class ViewComplianceDetailsComponent implements OnInit {
  isLoading: boolean = false;
  isLoadingFile: boolean = false;
  img: any;
  pdfSrc: any;
  details_Id: any;
  complainceDetailsData: any;
  permitId: any;
  permitDetails: any;
  uploadedDocs: any;
  isLoadingImg: boolean = false;
  data: any;
  currentId: number;
  application_Id;
  documentData: any = [];
  documentsFileData: any;
  countries: any = [];
  countryName: any;
  isDuplicate: boolean;
  allDocs = [];
  permitDocumentsLink: any = [];
  currentPermitDetails: any = [];
  ids: string;
  complianceIds: any=[];

  constructor(
    private _router: Router,
    private _service: AdminAnnualComplianceService,
    private _route: ActivatedRoute,
    private confirmDialogService: ConfirmDialogService,
    private toastService: ToastNotificationService,
    private countryService: CountryService,
    private sanitizer: DomSanitizer,
    private documentService: DocumentsServiceService,
    private _permitDocs: PermitTypeDocumentService,
    private _annualCompliance: AnnualComplianceService,
    
  ) {
    this.details_Id = this._route.snapshot.paramMap.get("id");
  }

  ngOnInit(): void {
   
    this.ids = this.getIdFromUrl(window.location.href);
    this.complianceIds= Number(this.ids);
    this.getIDs();
    this.getComplianceDetailsById();
 // this.currentId = Number(this.ids);
   
  }
  getIDs() {
    if (this.ids) {
      this.complianceIds = this.ids.split("_");
      this.currentId = this.complianceIds[0];
      this.getPermitData();
     // this.getPermitDetailsById();
    }
  }


  async getComplainceDetails() {
    this.isLoading = true;
    const response = await this._service
      .viewPermitDetails(this.details_Id)
      .toPromise();
    if (response != null) {
      this.complainceDetailsData = response;
      this.getCountries();
      this.permitId = this.complainceDetailsData.permit_id;
      this.getPermitDocumentsById();
    }

    this.isLoading = false;
  }
  getComplianceDetailsById() {
    this.isLoading = true;
    this._annualCompliance.getAnnualComplianceDetailsById(this.currentId).subscribe(
      (res: any) => {
        if (res) {
          this.currentPermitDetails = res;
        //  this.carrierId = res.carrier_id;
          this.getPermitRelatedDocsByID();
          this.getCountries();
        }
        this.isLoading = false;

      },
      (err) => {
        this.isLoading = false;
        console.error(err);
      }
    );
  }
  




  async getCountries() {
    try {
      this.isLoading = true;
      const result = await this.countryService.listAllCountries().toPromise();
      if (result) {
        this.countries = result;
        this.isLoading = false;
        this.countries.forEach((country) => {
          if (country.id == this.currentPermitDetails.country) {
            this.countryName = country.desc;
            return;
          }
        });
      }
    } catch (error) {
      this.isLoading = false;
    }
  }

  async getPermitData() {
    const response = await this._service
      .getPermitData(this.permitId)
      .toPromise();
    if (response) {
      this.permitDetails = response;
      this.data = this.permitDetails.permits[0];
    }
  }

  viewDoc(file: any) {
    console.log("Uploaded Docs", this.uploadedDocs);
    console.log("View Document", file);
    if (file != undefined) {
      this.isLoadingImg = true;
      this.pdfSrc = null;
      let id = file.shareId ?? file.document_link.substring(file.document_link.indexOf('#') + 1);
      console.log("Document Id", id);
      if (file.document_link.includes('.pdf')) {
        this.documentService.downloadpdf(id).subscribe(x => {
          let objectURL = URL.createObjectURL(x);
          this.pdfSrc = objectURL;
          this.isLoadingImg = false;
        });
      } else {
        this.documentService.download(id).subscribe(x => {
          let objectURL = URL.createObjectURL(x);
          this.pdfSrc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
          this.isLoadingImg = false;
        });
      }
    }
  }
  
  backToList() {
    this._router.navigate([`/annual-compliance/list/${this.currentPermitDetails.carrier_id}`])
  }
  patchDocs() {
    let newArr = [];
    this.permitDocumentsLink.forEach((element) => {
      const document_type_id = element.document_type_id;
      const foundEl: Array<any> = this.uploadedDocs.filter(
        (item) => item.document_type_id == document_type_id
      );
      if (foundEl && foundEl.length) {
        foundEl.forEach((el) => {
          newArr.push({
            document_type_id: document_type_id,
            fileName: el.file_name,
            id: el.id,
            document_link: el.document_link,
            date_created: el.date_created,
          });
        });
      }
    });
    this.allDocs = newArr.reduce((groups, item) => {
      const group = groups[item.document_type_id.toString()] || [];
      group.push(item);
      groups[item.document_type_id] = group;
      return groups;
    }, {});
    console.log("documents", this.allDocs);
  }
  
  async getPermitDocumentsById(): Promise<void> {
    try {
      const res: any = await this.documentService.getPermitById(this.currentPermitDetails.application_id).toPromise();
      if (res) {
        this.uploadedDocs = res;
        this.patchDocs();
      }
    } catch (err) {
      console.error(err);
    }
    this.isLoading = false;
  }
  
  async getPermitRelatedDocsByID(): Promise<void> {
    this.isLoading = true;
    try {
      const res: any = await this._permitDocs.getLinkedAndUnlinkedDoctypes(this.currentPermitDetails.permit_type_id).toPromise();
      if (res && res.PermitLinked) {
        this.permitDocumentsLink = res.PermitLinked;
        await this.getPermitDocumentsById();
      }
    } catch (err) {
      console.error(err);
    }
    this.isLoading = false;
  }
  getIdFromUrl(url: string): string | null {
    const regex = /\/(\w+)$/; // Matches a word at the end of the URL
    const matches = regex.exec(url);
    if (matches && matches.length >= 2) {
      return matches[1];
    }
    return null; // ID not found or invalid URL
  }

  
}
